import * as React from 'react';
import { CardStyle } from './Style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

type CardProps = {
  title: string;
  icon: IconProp;
  onClick?: () => void;
  iconTitle?: string;
};

const Card: React.FunctionComponent<CardProps> = ({
  title,
  icon,
  onClick,
  iconTitle = null,
}): JSX.Element => {
  const isLink = !!onClick;

  return (
    <CardStyle isLink={isLink} onClick={onClick} as={'a'}>
      <div className="card-title">{title}</div>
      <div className="icon">
        <FontAwesomeIcon size="2x" icon={icon} />
      </div>
      {iconTitle && <div>{iconTitle}</div>}
    </CardStyle>
  );
};

export default Card;
